import { createApp } from 'vue';
import L from 'leaflet';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import App from './App.vue';
import router from './router/index.js';
import '../assets/css/style.css';
import 'leaflet/dist/leaflet.css';

window.L = L;
gsap.registerPlugin(ScrollTrigger, SplitText);
const app = createApp(App);
app.use(router);
app.mount('#app');
